import { Skeleton } from "@mui/material";

const RenderLoading = () => {
  return (
    <div className="h-full w-full p-2 xl:p-4">
      <div className="card h-full w-full">
        <div className="w-11/12 mx-auto">
          <Skeleton className="w-full" height="140px" />
          <Skeleton className="w-full" height="100px" />
          <div className="flex justify-between items-center">
            <div className="w-2/5">
              <Skeleton className="w-full" height="80px" />
              <Skeleton className="w-full" height="80px" />
              <Skeleton className="w-full" height="80px" />
            </div>
            <div className="w-2/5">
              <Skeleton className="w-full" height="80px" />
              <Skeleton className="w-full" height="80px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenderLoading;
